/// <reference path="../include.ts" />

namespace project_common {

	import Orientation = project_common.Orientation;

	export class BannerUtil {

		public static getDefaultAppImageUrl(lang:Lang, orientation:Orientation, isLarge:boolean):string {
			return BannerUtil.getDefaultImageUrl(true, lang, orientation, isLarge);
		}

		public static getDefaultGuideImageUrl(lang:Lang, orientation:Orientation, isLarge:boolean):string {
			return BannerUtil.getDefaultImageUrl(false, lang, orientation, isLarge);
		}

		private static getDefaultImageUrl(isApp:boolean, lang:Lang, orientation:Orientation, isLarge:boolean):string {
			return '../static/img/banner-default-' + (isApp ? 'app' : 'guide') + '-' + orientation + '-' + (isLarge ? 'l' : 's') + '-' + (lang === Lang.ja ? 'ja' : 'en') + '.jpg';
		}

		public static getDefaultSpeciesIconUrl():string {
			return '../static/img/species-default-icon.png';
		}

		public static getDefaultSpeciesImageUrl(orientation:Orientation, isLarge:boolean):string {
			return '../static/img/species-default-' + orientation + '-' + (isLarge ? 'l' : 's') + '.png';
		}

		public static getDefaultZoneImageUrl():string {
			return '../static/img/zone-default.png';
		}





		private constructor() {
		}
	}
}
